import { useEffect } from 'react';
import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';
import { AlertModal } from '../../components/AlertModal';
import { MeetDomainEvents } from '../../../features/Meet/domain';
import { publish } from '../../../features/EventsBus';

export interface TooEarlyPageProps {
	onRetry?: () => void;
}

export default function TooEarlyPage({ onRetry }: TooEarlyPageProps) {
	const { t } = useTranslationsContext();

	useEffect(() => {
		publish(MeetDomainEvents.tooEarlyAccess);
	}, []);

	return (
		<AlertModal
			type="warning"
			title={t('errors.title_too_early')}
			message={t('errors.too_early')}
			onRetry={onRetry}
		/>
	);
}
